import * as React from "react";
import Box from "@mui/material/Box";
import dayjs from "dayjs";
// @ts-ignore
import {DEF} from '../../const.ts';
import css from "./GoodRow.module.css";
import clsx from "clsx";

export interface GoodRowData {
    id: number;
    epid: string;
    province: string;
    city: string;
    status: string;
    goodDate: string | Date;
    shortDescription: string;
    description: string;
}

export const GoodRow: React.FC<GoodRowData> = (data: GoodRowData) => {

    return (

        <Box className={clsx(css.goodRow)}>
            <Box className={clsx(css.head)}>
                <Box className={clsx(css.item)}>
                    <Box className={clsx(css.title)}>Epid</Box>
                    <Box className={clsx(css.value)}>{data.epid}</Box>
                </Box>

                <Box className={clsx(css.item)}>
                    <Box className={clsx(css.title)}>Województwo</Box>
                    <Box className={clsx(css.value)}>{data.province}</Box>
                </Box>

                <Box className={clsx(css.item)}>
                    <Box className={clsx(css.title)}>Miasto</Box>
                    <Box className={clsx(css.value)}>{data.city}</Box>
                </Box>

                <Box className={clsx(css.item)}>
                    <Box className={clsx(css.title)}>Status</Box>
                    <Box className={clsx(css.value)}>{data.status}</Box>
                </Box>

                <Box className={clsx(css.item)}>
                    <Box className={clsx(css.title)}>Data wydarzenia</Box>
                    <Box className={clsx(css.value)}>{dayjs(data.goodDate).format(DEF.DATE_FORMAT)}</Box>
                </Box>
            </Box>

            <Box className={clsx(css.body)}>
                <Box className={clsx(css.shortDescription)}>
                    {data.shortDescription}
                </Box>
                <Box className={clsx(css.description)}>
                    {data.description}
                </Box>

            </Box>
        </Box>

    )
}